<template>
  <component :is="currentForm" />
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@/stores'

// 导入 9 个表单
import TeachingProjectForm from '@/components/forms/TeachingProjectForm.vue'
import ResearchProjectForm from '@/components/forms/ResearchProjectForm.vue'
import ConferenceForm from '@/components/forms/ConferenceForm.vue'
import PaperForm from '@/components/forms/PaperForm.vue'
import PatentForm from '@/components/forms/PatentForm.vue'
import SoftwareForm from '@/components/forms/SoftwareForm.vue'
import MonographForm from '@/components/forms/MonographForm.vue'
import HonorForm from '@/components/forms/HonorForm.vue'
import OtherForm from '@/components/forms/OtherForm.vue'

const { activeTab } = storeToRefs(useAppStore())

const formMap = {
  'teaching-project': TeachingProjectForm,
  'research-project': ResearchProjectForm,
  conference: ConferenceForm,
  paper: PaperForm,
  patent: PatentForm,
  software: SoftwareForm,
  monograph: MonographForm,
  award: HonorForm,
  other: OtherForm
}

const currentForm = computed(() => formMap[activeTab.value] ?? TeachingProjectForm)
</script>